export default "__VITE_ASSET__aah1UHw$__"